import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { SecureCodingHeroSection } from "@/components/insights/secure-coding/SecureCodingHeroSection";
import { SecureCodingTakeaway } from "@/components/insights/secure-coding/SecureCodingTakeaway";
import { SecureCodingFounderQuote } from "@/components/insights/secure-coding/SecureCodingFounderQuote";
import { SecureCodingOwaspTop10 } from "@/components/insights/secure-coding/SecureCodingOwaspTop10";
import { SecureCodingBestPractices } from "@/components/insights/secure-coding/SecureCodingBestPractices";
import { SecureCodingChecklist } from "@/components/insights/secure-coding/SecureCodingChecklist";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { TableOfContents } from "@/components/TableOfContents";

const SecureCodingPractices = () => {
  return (
    <>
      <InsightEngagementTracker slug="secure-coding-practices" title="Secure Coding Practices" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb category="Development" currentPage="Secure Coding Practices" />
        <SecureCodingHeroSection />
        <AnimatedSection delay={100} className="mt-10 sm:mt-12"><SecureCodingTakeaway /></AnimatedSection>
        <AnimatedSection delay={50} className="mt-8 sm:mt-10"><SecureCodingFounderQuote /></AnimatedSection>
        <div className="section-divider" />
        <AnimatedSection delay={0}><SecureCodingOwaspTop10 /></AnimatedSection>
        <AnimatedSection delay={0}><SecureCodingBestPractices /></AnimatedSection>
        <AnimatedSection delay={0}><SecureCodingChecklist /></AnimatedSection>
        <AnimatedSection delay={0}><InsightFAQSection insightSlug="secure-coding-practices" /></AnimatedSection>
        <AnimatedSection delay={0}><RelatedTools insightSlug="secure-coding-practices" /></AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default SecureCodingPractices;
